module.exports = __webpack_public_path__ + "static/media/money-bill-stack.e14c07b0.svg";